// Sondeo del estado real de una venta de Farmacia (PR 8.3) — cierra "vendida y facturada falso": la
// arquitectura de facturación es asíncrona (bandeja de salida, PLAN.md §6.1), así que el HTTP 200 de
// "vender" solo confirma que la orden/pago/factura se registraron localmente, no que el SRI ya autorizó
// nada. Misma lógica de temporización que ya prueba el CRM en
// `packages/web/src/web/pages/admin/factura-enviar-correo-logica.ts` (SONDEO_ENTREGA_MS/debeSondearEntrega),
// copiada acá (no importada) porque hce-chart es un paquete de frontend separado que no puede importar de
// packages/web. Pura, sin React ni red: fácil de probar sin DOM.

/**
 * Cuándo el panel de resultado de la venta pregunta solo «¿ya la autorizaron?», contado desde que aparece:
 * a los 15, 45 y 120 s. Como mucho estas 3 llamadas; se detiene al autorizarse o rechazarse la factura, o
 * al desmontarse el panel (orden nueva, u otra venta).
 */
export const SONDEO_ENTREGA_MS = [15_000, 45_000, 120_000] as const;

export type EstadoFacturaVenta = { estado: string } | null;

/**
 * ¿Tiene sentido seguir consultando el estado real? Solo mientras hay una factura y su estado visible
 * sigue "pendiente" (ni autorizada, ni rechazada, ni de prueba, ni anulada, ni sin factura).
 */
export function debeSondearEntrega(factura: { invoiceId: number | null; estado: EstadoFacturaVenta }): boolean {
  return factura.invoiceId != null && factura.estado?.estado === 'pendiente';
}
